import {useContext} from 'react';

import {OmicronContext} from './OmicronClientContext';

export const useOmicron = () => useContext(OmicronContext);
